// shared/MarketplaceHeader.jsx
// Used by FastMaxLanding (route "/tienda")
// "Soy Tienda" is a Link that navigates to the service landing page.

import React from "react";
import { Link } from "react-router-dom";
import { Search, Store, ChevronRight } from "lucide-react";
import { brand } from "./brand";

export function MarketplaceHeader() {
  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur border-b border-slate-100 shadow-sm">
      <nav className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-2 px-4 py-2 sm:h-14 sm:flex-nowrap sm:gap-3 sm:py-0">

        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 shrink-0">
          <img
            src={`${process.env.PUBLIC_URL}/logo.png`}
            alt="FAST MAX"
            className="h-7 w-auto"
          />
          <span
            className="hidden sm:inline text-base font-extrabold italic tracking-wide"
            style={{ color: brand.primary }}
          >
            FAST MAX
          </span>
        </Link>

        {/* Right: Search + Auth */}
        <div className="order-3 flex w-full min-w-0 shrink-0 items-center justify-between gap-1.5 sm:order-none sm:w-auto sm:justify-end sm:gap-2">
          <Link
            to="/"
            className="inline-flex min-w-0 flex-1 items-center justify-center gap-1 rounded-xl border px-2 py-1.5 text-[11px] font-semibold transition-all duration-200 hover:bg-slate-50 sm:flex-none sm:gap-1.5 sm:px-3 sm:text-xs"
            style={{ background: "white", color: brand.primary, borderColor: brand.primary }}
          >
            <Store className="size-3.5 shrink-0" />
            <span>Soy Tienda</span>
          </Link>

          <Link
            to="/buscar"
            className="grid size-8 shrink-0 place-items-center rounded-xl border border-slate-200 bg-white transition-colors hover:bg-slate-50"
            aria-label="Buscar"
          >
            <Search className="size-4 text-slate-500" />
          </Link>

          <Link
            to="/register"
            className="inline-flex min-w-0 flex-1 items-center justify-center rounded-xl border border-slate-200 bg-white px-2 py-1.5 text-center text-[11px] font-semibold leading-tight text-slate-700 transition-colors hover:bg-slate-50 sm:flex-none sm:px-3 sm:text-xs sm:leading-normal"
          >
            Crear cuenta
          </Link>

          <Link
            to="/login"
            className="inline-flex min-w-0 flex-1 items-center justify-center gap-1 rounded-xl px-2 py-1.5 text-[11px] font-semibold text-white sm:flex-none sm:px-3 sm:text-xs"
            style={{ background: brand.primary }}
          >
            
            Iniciar sesión
            <ChevronRight className="size-3.5 shrink-0" />
          </Link>
        </div>
      </nav>
    </header>
  );
}
